/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO #458 Prototyp zpracování se zobrazením celé šablony.
// import EventEmitter from 'eventemitter3';
// import get from 'lodash/get';
// import isNil from 'lodash/isNil';
// import isObject from 'lodash/isObject';

// TODO #458 Prototyp zpracování se zobrazením celé šablony.
// import Numeric from '../numeric/numeric';
import ScheduleBackground from './schedule-background';
// import ScheduleEmpty from './schedule-empty';
// import ScheduleInfo from './schedule-info';
import ScheduleLayer from './schedule-layer';
// import ScheduleRegion from './schedule-region';

// TODO #458 Unit testy.
// TODO #458 Zahodit připravené ale deaktivované zpracování pozadí šablon?
// - Pokud by vyžadovalo složitější úpravy tak ano.
/**
 * Utilita pro plánování šablon.
 */
class ScheduleLayout {
  /**
   * Detekuje a vytvoří strategie pro šablonu.
   * @param {ContentInfo} contentInfo Informace o obsahu zařízení.
   * @param {Layout} layout Šablona.
   * @param {ViewerRegistry} viewerRegistry Registr informací o typech médií.
   * @returns {Array.<ScheduleStrategy>} Seznam detekovaných strategií.
   */
  static createStrategies(contentInfo, layout, viewerRegistry) {
    // TODO #138 Zavést registry pro detekce strategií?
    return (
      contentInfo.store
        .filter('layer', { where: { parentLayoutId: { '===': layout.id } } })
        .map((layer) => new ScheduleLayer(contentInfo, layer, viewerRegistry))
        // TODO #458 #532: Pozadí nezaobaluje layer (např. aby omezilo svoji velikost),
        // takže nepůjde realizovat zanořené/vnitřní šablony bez refaktoringu!
        .concat(
          // TODO #532: Nyní lze z Ki-Wi Serveru odeslat jako pozadí jen a pouze obrázek.
          // Při pokusu o hack odesláním videa sice toto hraje, ale pouze první opakování,
          // pak se odřadí src a video element zůstane viset. Hlasitost a duration se sice
          // počítala díky ScheduleRegion "dobře" (těžko říct bez specifikace), ale vlastně
          // kvůli nemožnosti slušného přehrávání obsahu se zvukem nemá cenu nyní složitě
          // řešit spolehlivý výpočet volume a playDuration, když nefunguje vždy přehrávání.
          /*
          new ScheduleRegion(
            // Typ Content nesoucí volitelné médium jako pozadí (kvůli volume v ScheduleRegion).
            { medium: layout.medium },
            new ScheduleBackground(contentInfo.session, layout, viewerRegistry)
          )
          */
          new ScheduleBackground(contentInfo.session, layout, viewerRegistry)
        )
    );
  }
}

export default ScheduleLayout;

// TODO #458 Prototyp zpracování se zobrazením celé šablony.
// - Nyní se již ScheduleInfo#layout používá pro rodičovskou šablonu. Refaktorovat před použitím!
// - Tato strategie by měla realizovat odpočet času.
// - Každopádně vracet jen jednu ScheduleStrategy.
//   Asi ne, pokud se mají podporovat i šablony v playlistech a ne jen jako hlavní obsah.
// /**
//  * Strategie přehrávání pro šablonu.
//  * @implements {ScheduleStrategy}
//  */
// class ScheduleLayout {
//   /**
//    * Vytvoří instanci.
//    * @param {DS} store Datový sklad.
//    * @param {Session} session Sezení s nastavením zařízení.
//    * @param {Array.<Layer>} layerArray Seznam všech vrstev.
//    * @param {Layout} layout Šablona.
//    * @param {ViewerRegistry} viewerRegistry Registr informací o typech médií.
//    * @returns {ScheduleLayout} Nová instance.
//    */
//   constructor (store, session, layerArray, layout, viewerRegistry) {
//     if (!isObject(layout)) {
//       throw new TypeError(`Invalid layout ${layout}.`);
//     }
//     this.emitter = new EventEmitter();
//     this.layout = layout;
//     this.schedulePlan = null;
//     this.session = session;
//     this.viewerRegistry = viewerRegistry;
//   }

//   /** @inheritdoc */
//   destroy () {
//     // Není potřeba nic rušit.
//     // Přítomno pouze pro splnění rozhraní.
//   }

//   /**
//    * Určí informace pro přehrání média.
//    * @param {number} cycleIndex Pořadí cyklu, ke kterému vytvořit informace.
//    * @private
//    * @returns {ScheduleInfo} Informace pro přehrání média.
//    */
//   getInfo (cycleIndex) {
//     const {layout} = this;
//     // TODO #458 Hotfix zobrazení šablony jako pozadí.
//     const {medium} = layout;
//     if (isNil(medium)) {
//       return new ScheduleInfo({
//         cycleIndex,
//         iterationIndex: 0,
//         layout,
//         session: this.session
//       });
//     }
//     return new ScheduleInfo({
//       cycleIndex,
//       iterationIndex: 0,
//       layout,
//       medium,
//       session: this.session,
//       viewerRegistry: this.viewerRegistry
//     });
//   }

//   /** @inheritdoc */
//   go () {
//     const fromSchedulePlan = this.schedulePlan;
//     const fromCycleIndex = get(fromSchedulePlan, 'cycleIndex', null);
//     const toCycleIndex = this.planCycleIndex(fromCycleIndex);
//     const toSchedulePlan = {
//       cycleIndex: toCycleIndex,
//       scheduleInfo: this.getInfo(toCycleIndex)
//     };
//     const toScheduleInfo = toSchedulePlan.scheduleInfo;
//     this.schedulePlan = toSchedulePlan;
//     // Vyvolání události a vrácení výsledku.
//     this.emitter.emit('gone', toScheduleInfo);
//     return toScheduleInfo;
//   }

//   /** @inheritdoc */
//   off (...args) {
//     this.emitter.off(...args);
//   }

//   /** @inheritdoc */
//   on (...args) {
//     this.emitter.on(...args);
//   }

//   /** @inheritdoc */
//   plan (offset) {
//     if (!Numeric.isIndex(offset)) {
//       throw new TypeError(`Invalid offset ${offset}.`);
//     }
//     return (
//       Array(offset).fill()
//       .reduce(
//         (acc) => {
//           const previousSchedulePlan = acc[acc.length - 1];
//           const previousCycleIndex = get(previousSchedulePlan, 'cycleIndex', null);
//           const cycleIndex = this.planCycleIndex(previousCycleIndex);
//           const scheduleInfo = this.getInfo(cycleIndex);
//           return acc.concat({cycleIndex, scheduleInfo});
//         },
//         [this.schedulePlan]
//       )
//       .slice(1)
//       .map((schedulePlan) => schedulePlan.scheduleInfo)
//     );
//   }

//   /**
//    * Naplánuje pořadí cyklu následujícího slajdu.
//    * @param {null|number} fromCycleIndex Pořadí cyklu předchozího slajdu.
//    * @private
//    * @returns {number} Pořadí cyklu.
//    */
//   planCycleIndex (fromCycleIndex) {
//     if (isNil(fromCycleIndex)) {
//       // Bez výchozího cyklu se určují cykly od začátku. Číslování od nuly.
//       return 0;
//     }
//     // Přičtení offsetu k aktuálnímu cyklu.
//     return fromCycleIndex + 1;
//   }

//   /** @inheritdoc */
//   skip () {
//     // Není potřeba nic přeskakovat.
//     // Přítomno pouze pro splnění rozhraní.
//   }

//   /** @inheritdoc */
//   stop () {
//     // Není potřeba nic zastavovat.
//     // Přítomno pouze pro splnění rozhraní.
//   }

//   /** @inheritdoc */
//   toString () {
//     return `ScheduleLayout {layout: ${this.layout}}`;
//   }
// }
